import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Constant from "./Constant";
import GridConfig from "./GridConfig";
import { Header } from './Header';
import { Footer } from './Footer';

export default class Constants extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: ((props.Type == 1 || props.Type == 2 || props.Type == 4 || props.Type == 7 || props.Type == 11 || props.Type == 12 || props.Type == 13) ? 'constantfororganization' : 'constant'),
            data: null,
            loading: true,
            configName: 'constants_grid',
            moduleName: 'دسته بندی ها',
            filters: {
                type: props.Type
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Constant Type={this.state.filters.type} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Constant Type={this.state.filters.type} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "عنوان", show: true },
                { field: "code", caption: "کد", show: this.state.filters.type!==10 },
                { field: "editDateString", caption: "تاریخ ثبت", show: true },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id',flex:0.5, filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                ]
            }
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-block">
                <div className="card card-bordered card-stretch">
                    <div className="card-inner-group">
                        <div className="card-inner p-0">
                            {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false })}
                            {this.renderAgGrid({
                                columnDefs: this.getColumns()
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent()
            ];

        return contents;
    }
}